import { render } from "./CategoriserConfig.vue?vue&type=template&id=0d463c84"
import script from "./CategoriserConfig.vue?vue&type=script&lang=js"
export * from "./CategoriserConfig.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__